import { apiRequest } from './apiClient';
import {
  MtrErroImportacao,
  MtrLoteImportacao,
  MtrLotesResponse,
} from '../types/mtrImportacao';

function toQuery(params: Record<string, string | number | undefined>): string {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== '') {
      query.set(key, String(value));
    }
  });

  const serialized = query.toString();
  return serialized ? `?${serialized}` : '';
}

export function importarLoteMtr(
  accessToken: string,
  payload: {
    empresaOrigemId: string;
    sistemaOrigem: string;
    formato: 'json' | 'csv';
    nomeArquivo?: string;
    conteudo: string;
  }
): Promise<MtrLoteImportacao> {
  return apiRequest<MtrLoteImportacao>('/integracoes/mtrs/lotes/importar', accessToken, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function listLotesMtr(accessToken: string): Promise<MtrLotesResponse> {
  return apiRequest<MtrLotesResponse>(
    `/integracoes/mtrs/lotes${toQuery({ pageSize: 50 })}`,
    accessToken
  );
}

export function listErrosLoteMtr(
  accessToken: string,
  loteId: string
): Promise<MtrErroImportacao[]> {
  return apiRequest<MtrErroImportacao[]>(
    `/integracoes/mtrs/lotes/${loteId}/erros`,
    accessToken
  );
}

export async function downloadErrosLoteMtr(
  accessToken: string,
  loteId: string
): Promise<void> {
  const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:4000/api/v1';
  const response = await fetch(`${baseUrl}/integracoes/mtrs/lotes/${loteId}/erros.csv`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  if (!response.ok) {
    throw new Error('Não foi possível baixar o relatório de erros.');
  }

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `erros-mtr-lote-${loteId}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
